import React, { useState, useEffect } from 'react';
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import api from '../services/api';

export default function ConfigPage({ setPage }) {
  const configFields = [
    'defaultReorderPoint',
    'defaultSupplierThreshold',
    'defaultWarehouseBuffer',
    'defaultServiceLevel'
  ];

  const [cfg, setCfg] = useState({});
  const [form, setForm] = useState({
    defaultReorderPoint: '',
    defaultSupplierThreshold: '',
    defaultWarehouseBuffer: '',
    defaultServiceLevel: ''
  });

  const [err, setErr] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    api.get('/config')
      .then((res) => {
        const backendData = res.data || {};
        const updatedForm = {};
        configFields.forEach(field => {
          updatedForm[field] = backendData[field] ?? '';
        });
        setCfg(backendData);
        setForm(updatedForm);
      })
      .catch((e) => setErr(e.message));
  }, []);

  const onCh = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const upd = async () => {
    setErr('');
    setSuccess('');
    try {
      const { data } = await api.put('/config', form);
      setCfg(data.thresholds || data);
      setSuccess('Configuration updated successfully!');
    } catch (e) {
      setErr(e.response?.data?.error || 'Update failed');
    }
  };

  return (
    <Container className="card-transparent p-4 d-flex flex-column align-items-center">
      <Header />
      <Navbar setPage={setPage} />
      <h2 className="text-center mb-4" style={{ color: '#4a4a4a' }}>Configuration</h2>

      {err && <Alert variant="danger" className="w-100 mb-3">{err}</Alert>}
      {success && <Alert variant="success" className="w-100 mb-3">{success}</Alert>}

      <Form className="mb-4 w-75">
        {configFields.map((key) => (
          <Form.Group key={key} className="mb-3">
            <Form.Label style={{ color: '#6c757d' }}>{key}</Form.Label>
            <Form.Control
              name={key}
              type="number"
              value={form[key]}
              onChange={onCh}
              className="form-control-light"
            />
          </Form.Group>
        ))}
        <Button onClick={upd} variant="primary" className="w-100 py-2" style={{ backgroundColor: '#6c5ce7' }}>
          Update Configuration
        </Button>
      </Form>

      <h5 className="text-center mb-4" style={{ color: '#4a4a4a' }}>Current Configuration</h5>

      <Row className="w-75">
        {Object.entries(cfg).map(([key, value]) => (
          <Col xs={12} sm={6} md={4} key={key} className="mb-3">
            <div className="d-flex justify-content-between align-items-center p-3" style={{
              backgroundColor: '#f7f7f7',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
            }}>
              <span className="text-muted" style={{ fontSize: '1rem' }}>{key}</span>
              <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#333' }}>{value}</span>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
